import { Button, Dialog } from '@dnb/eufemia';
import { chevron_down } from '@dnb/eufemia/icons';
import { RecentPagesTree } from '@portals/shared-frontend/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RecentPagesDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <Dialog
      noAnimation
      onClose={() => setIsOpen(false)}
      openState={isOpen}
      title="Pinned & Recently Visited Pages"
      trigger={(props) => (
        <Button
          {...props}
          icon={chevron_down}
          icon_position="left"
          on_click={() => setIsOpen(true)}
          size="small"
          variant="tertiary"
        />
      )}
    >
      <RecentPagesTree onNavigate={handleNavigate} />
    </Dialog>
  );
}
